import registrationStep from "../../registrationStep";
import Agreement from "./Agreement";

export default registrationStep(Agreement, "agreement", "complete");



// WEBPACK FOOTER //
// ./src/registration/components/Agreement/index.js